import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import { UserProfileForm } from "../UserProfileForm";
import { User } from "../../types";
import { isMobile } from "react-device-detect";

type Props = {
  title: string;
  isOpen: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (data: Partial<User>) => void;
};

export const CustomerModal: React.FC<Props> = ({
  title,
  isOpen,
  isSubmitting,
  onClose,
  onSubmit,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={isMobile ? "xs" : "2xl"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <UserProfileForm
            isSubmitting={isSubmitting}
            editable
            isAdmin
            onSubmit={onSubmit}
            validable={false}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
